import { defineStore } from "pinia";
import type { KybFormData } from "@two-ui/components/onboarding/kyb-form-data";

const STORAGE_KEY = "kyb-form-data";
const CURRENT_PAGE_KEY = "kyb-current-page";

export const useKybFormStore = defineStore("kybForm", {
  state: () => ({
    formData: null as Partial<KybFormData> | null,
    currentPage: null as number | null,
  }),
  actions: {
    setFormData(data: Partial<KybFormData>) {
      this.formData = data;
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch {}
    },

    setCurrentPage(page: number) {
      this.currentPage = page;
      try {
        sessionStorage.setItem(CURRENT_PAGE_KEY, String(page));
      } catch {}
    },

    loadFromStorage(): {
      formData: Partial<KybFormData> | null;
      currentPage: number | null;
    } {
      try {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        if (stored) {
          this.formData = JSON.parse(stored);
        }
        const storedPage = sessionStorage.getItem(CURRENT_PAGE_KEY);
        if (storedPage !== null) {
          this.currentPage = Number(storedPage);
        }
      } catch {}
      return { formData: this.formData, currentPage: this.currentPage };
    },

    clear() {
      this.formData = null;
      this.currentPage = null;
      try {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(CURRENT_PAGE_KEY);
      } catch {}
    },
  },
});
